import React from 'react'
import { AlertTriangle, ArrowUpRight } from 'lucide-react'
import { Button, Card } from '@/shared/ui'
import type { OportunidadesGapStats } from '../services/statsService'

type Props = {
  stats: OportunidadesGapStats | null
  role?: string | null
  forceShow?: boolean
}

export default function OportunidadesUpgradeHint({ stats, role, forceShow }: Props) {
  if (!stats) return null
  const hasLimit = stats.hasAssetLimit || !!forceShow
  if (!hasLimit) return null
  if (role !== 'member') return null
  if (!stats.missedToday || stats.missedToday <= 0) return null

  const missedLabel = stats.missedToday.toLocaleString('pt-BR')

  const handleClick = () => {
    try {
      window.location.href = '/my-plans'
    } catch {
      // no-op
    }
  }

  return (
    <div className="mt-6 mb-6">
      <Card className="rounded-xl border-amber-500/60 bg-gradient-to-r from-amber-500/20 via-red-500/20 to-violet-500/20 px-4 py-4 shadow-lg shadow-amber-500/25 md:px-6 md:py-5">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-start gap-3">
            <div className="mt-1 rounded-full bg-amber-500/30 p-2.5 text-amber-50">
              <AlertTriangle className="h-6 w-6" />
            </div>
            <div className="flex flex-col">
              <div className="text-sm font-semibold text-amber-50 md:text-base">
                Hoje você deixou de receber oportunidades que já estão no radar dos assinantes Elite!
              </div>
              <div className="mt-5 text-center text-2xl font-extrabold text-amber-50 md:text-left md:text-3xl">
                
                <span className="inline-flex rounded-full bg-amber-500/30 px-2 py-0.5 ml-1 text-lg font-extrabold text-amber-100 md:text-2xl">Total: {missedLabel} oportunidades</span>
              </div>
              <div className="mt-5 text-left text-xs text-amber-100/90 md:text-left md:text-sm">
                Você não precisa de mais alertas. Você precisa dos alertas certos, no momento certo
              </div>
            </div>
          </div>
          <div className="flex justify-center md:justify-end">
            <Button
              type="button"
              onClick={handleClick}
              className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-violet-500 to-emerald-500 px-5 py-2.5 text-sm font-semibold text-white shadow-xl shadow-emerald-500/30 hover:from-violet-400 hover:to-emerald-400 md:px-6 md:py-3 md:text-base"
            >
              Liberar mais moedas e enxergar oportunidades reais
              <ArrowUpRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}
